/* global THREE */
import 'three';

import AbstractObject from './object';

import LayerHTML from './html/html.layer';

export default class Layer {

  constructor() {
    this.mesh = new THREE.Object3D();
    this.htmlLayer = new LayerHTML();
  }

  set(layer) {
    if (layer instanceof Layer) {
      this.mesh = layer.mesh;
      this.htmlLayer.clear();
      this.htmlLayer.addLayer(layer.htmlLayer);
    } else {
      throw new Error('Layer should be instance of Layer');
    }
  }

  addLayer(layer) {
    if (layer instanceof Layer) {
      this.addMesh(layer.mesh);
      this.htmlLayer.addLayer(layer.htmlLayer);
    } else {
      throw new Error('Layer should be instance of Layer');
    }
  }

  addObject(object) {
    if (object instanceof AbstractObject) {
      this.addMesh(object.mesh);
      this.htmlLayer.addLayer(object.htmlLayer);
    } else {
      throw new Error('Object should be instance of Object');
    }
  }

  addMesh(mesh) {
    if (mesh instanceof THREE.Object3D) {
      this.mesh.add(mesh);
    } else {
      throw new Error('Object should be instance of THREE.Object3D');
    }
  }

  removeObject(obj) {
    if (obj instanceof THREE.Mesh || obj instanceof THREE.Line)
    {
      if (obj.geometry) {
        obj.geometry.dispose();
        obj.geometry = null;
      }
      if (obj.material) {
        if (obj.material.length) {
          for (let i = 0; i < obj.material.length; i++)
            obj.material[i].dispose();
        } else {
          obj.material.dispose();
        }
        obj.material = null;
      }
    }
    else
    {
      if (obj.children !== undefined) {
        while (obj.children.length > 0) {
          this.removeObject(obj.children[0]);
          obj.remove(obj.children[0]);
        }
      }
    }
  }

  clear() {
    for (let i = this.mesh.children.length - 1; i >= 0; i--) {
      // VladP: Properly remove the child (geometry/material of the object must be disposed in Three.js)
      this.removeObject(this.mesh.children[i]);
      this.mesh.remove(this.mesh.children[i]);
    }

    this.htmlLayer.clear();
  }

  show() {
    this.mesh.visible = true;
    this.htmlLayer.show();
  }

  hide() {
    this.mesh.visible = false;
    this.htmlLayer.hide();
  }

}



// WEBPACK FOOTER //
// ./src/object-view/misc/layer.js